import { isNumber } from '@/helpers/is';

const roundTransform = (value, params = {}) => {
  const { digits = 0 } = params;

  const numericValue = typeof value === 'string' && value.trim() !== '' ? Number(value) : value;

  if (!isNumber(numericValue)) {
    return value;
  }

  const factor = 10 ** digits;

  const rounded = Math.round(numericValue * factor) / factor;

  return rounded;
};

export default roundTransform;
